export class ChoiceSelection {
    constructor({ selectedOption, event }) {
        this.event = event;
        this.selectedOption = selectedOption;
        this.selectionDate = this.selectedOption.context.app.appClock.currentDate;
        this.detectIfTryFailed();
    }
    event;
    selectedOption;
    selectionDate;
    isFailedAttempt = false;
    get question() {
        return this.selectedOption.parent;
    }
    detectIfTryFailed() {
        if (!this.selectedOption.shouldBeSelected &&
            this.question.choiceStore.numberOfTries > this.question.choiceAttempts.numberOfFailedAttempts + 1) {
            this.isFailedAttempt = true;
            this.question.actorEvents.fireEvent({ type: 'failedtry' });
            return;
        }
    }
}
